import { useEffect } from "react";

// Petit retour visuel après un paiement Stripe Checkout — la page vers laquelle on revient
// (success_url/cancel_url) porte juste ?payment=success|cancelled en query string, pas de
// page de confirmation dédiée par type d'achat. Nettoie l'URL ensuite pour ne pas rejouer
// l'alerte à un rafraîchissement.
export function usePaymentReturnBanner() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");
    if (!payment) return;
    if (payment === "success") {
      window.alert("Paiement confirmé ! Tu recevras une confirmation dès que ta demande sera traitée.");
    }
    params.delete("payment");
    const qs = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
  }, []);
}
